// ** React Imports
import { useState } from "react";

// ** Redux & Store & Actions
import { connect, useSelector } from "react-redux";
import { setLocation as setLocationAction } from "store/modules/auth";
import { getGeolocationInitialData as getGeolocationInitialDataAction } from "store/modules/global";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import LocationAutocomplete from "components/layout/LocationAutocomplete";
import selectorActivator from "../selectorActivator";

// #####################################################

const LocationContent = ({
	city,
	region,
	country,
	regionName,
	cityName,
	setLocation,
	setShowErrorMessage,
	setShowErrorMessageLong,
}) => {
	const { t } = useTranslation(["common", "landing"]);

	const isOpenInAuthModal = useSelector(
		(state) => state.globalCommon.authModal.isOpen
	);
	const isOpenRegistrationVerifyEmailModal = useSelector(
		(state) => state.globalCommon.registrationVerifyEmailModal.isOpen
	);
	const isOpenRegistrationVerifyPhoneModal = useSelector(
		(state) => state.globalCommon.registrationVerifyPhoneModal.isOpen
	);

	const isSelected = Boolean(
		(typeof city === "number" &&
			typeof region === "number" &&
			typeof country === "string") ||
			(typeof city === "string" &&
				city.length > 0 &&
				region === null &&
				typeof country === "string")
	);

	const [selected, setSelected] = useState(
		isSelected
			? {
					country,
					regionId: region,
					regionName,
					cityId: city,
					cityName: cityName ? cityName : city ? city : null,
			  }
			: null
	);

	// #####################################################

	return (
		<LocationAutocomplete
			location={selected}
			label={t("filtersAndSelectors:locationLabel")}
			onAccept={(data) => {
				setSelected(data);
				setLocation({
					cityName: data?.cityName,
					city: data?.cityId,
					region: data?.regionId,
					regionName: data?.regionName,
					country: data?.country,
				});
				setShowErrorMessage(data?.showError && !data?.cityId);
				setShowErrorMessageLong(
					data?.showError && data?.cityId?.length > 50
				);
			}}
			inputComponentProps={{
				register: true,
				active: isSelected,
				withGeolocation: true,
			}}
			useLayerOptions={{
				overflowContainer: false,
			}}
			selectorProps={{
				activator: (props) =>
					selectorActivator({
						label: t("landing:register.locationPlaceholder"),
						style: {
							width: "100%",
							marginTop: 0,
						},
						...props,
					}),
				containerTopMarginValue: 2,
				selectCustomCityOnChange: true,
				isRegister: true,
				alwaysLight: true,
			}}
			onlyCities
			noBold
			noPad
			noMaxWidth
			hideLabel
			alwaysLight
			withGeolocation
			notCleanInputInUseEffect={true}
			isLanding
			closeWithoutEnableScroll={
				isOpenInAuthModal ||
				isOpenRegistrationVerifyEmailModal ||
				isOpenRegistrationVerifyPhoneModal
			}
		/>
	);
};

// #####################################################

const mapStateToProps = ({
	auth: {
		register: {
			registerForm: {
				location: { city, cityName, region, regionName, country },
			},
		},
	},
}) => ({
	city,
	cityName,
	region,
	regionName,
	country,
});

const mapDispatchToProps = (dispatch) => ({
	setLocation: (location, errorFrontend) =>
		dispatch(setLocationAction(location, errorFrontend)),
	getGeolocationInitialData: (latitude, longitude, extend) =>
		dispatch(getGeolocationInitialDataAction(latitude, longitude, extend)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationContent);

// #####################################################
